// ADMIN AUTH
export const LOGIN_ADMIN = "/api/login";
export const ADMIN_FORGOT_PASSWORD = "/api/forgot-password";
export const RESET_PASSWORD = "/api/reset-password";

// API CONSTANTS FOR NEW ORDER REQUEST
export const DEALER_CODES = "/api/dealers";
export const DELAER_DETAILS = "/api/dealer-details";
// BD person
export const BD_PERSON = "/api/bd-persons";

// Products
export const PRODUCT_WITH_PRICE = "/api/product-details ";
export const ALL_PRODUCTS = "/api/products";
// All Products List
export const ALL_PRODUCTS_LIST = "/api/all-product-list";
// All Products Pricing
export const ALL_PRODUCTS_PRICING = "/api/product-pricing";

// Orders List
export const ORDER_REQUEST_LIST = "/api/order-request";
export const ORDERS_LIST = "/api/orders";
export const FAILED_ORDERS_LIST = "/api/failed-orders";
export const DRAFT_ORDERS_LIST = "/api/order-draft-listing";

// Place Order Request
export const PLACE_ORDER_REQUEST = "/api/create-order-request";
export const CREATE_ORDER_DRAFT = "/api/order-draft";
export const DELETE_ORDER_DRAFT = "/api/order-draft/delete";

// Order Details
export const ORDER_DETAILS = "/api/order-detail";

// Draft Order Details
export const DRAFT_ORDER_DETAILS = "/api/order-draft/detail";
// Orders error
export const ERROR_LOG = "/api/error-logs";
// Clone Order
export const CLONE_ORDER = "/api/clone-order";

// Sub Orders
export const SUB_ORDER_ITEMS = "/api/fetch-product-details-sub-order";
// Create Sub Order
export const CREATE_SUB_ORDER = "/api/create-sub-order";
// SubOrders list
export const SUB_ORDERS_LIST = "/api/sub-orders";
export const SUB_ORDERS_LIST_DEALER = "/api/dealer/sub-orders/list";
export const BLANKET_ORDERS_LIST_WITH_PENDING_SUB_ORDERS_BY_DEALER =
  "/api/dealer/pending-suborders";
// Sub Order details
export const SUB_ORDER_DETAILS = "/api/sub-order/details";
export const DEALER_SUB_ORDER_DETAILS = "/api/dealer/sub-orders/details";

// order refresh api
export const ORDER_REFRESH_API = "/api/update-order-status";
export const SUBORDER_REFRESH_API = "/api/update-sub-order-status";
